import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxGym from '../../util/remote/ajaxGym';

const initialState = { 
    GymInvoiceListing: null,
    GymInvoiceCount: '...',
    metaData: null,
    currentPage: 1,
    mounted: false,
    searchHint: '',
    selectedGymInvoice: false,
    dateRange: { opening_date: "", closing_date: "" },
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
    }
};


const GymInvoiceContext = createContext();

export const GymInvoiceProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

   useEffect(()=>{
      if(state.mounted){
        getGymInvoices(false, true);
      }
    }, [state.currentPage])


  const getGymInvoices = async (refresh=false, nextPage=false, period = null, specificDates = null) => {

    dispatch({ type: "mounted", payload: true });

    if(!refresh && Array.isArray(state.GymInvoiceListing) && !nextPage){
      return
    }

      dispatch({ type: 'GymInvoiceListing', payload: null });
      const server_response  = await ajaxGym.fetchInvoiceListing({
        page: refresh? 1:  state.currentPage,
        opening_date: period?.opening_date || state.dateRange?.opening_date,
        closing_date: period?.closing_date || state.dateRange?.closing_date,
        specific_dates: specificDates
      });
      if(server_response.status === "OK"){
          dispatch({ type: 'GymInvoiceListing', payload: server_response.details.data });
          dispatch({ type: 'metaData', payload: server_response.details.meta });
      }else{
        dispatch({ type: 'GymInvoiceListing', payload: "404" });
        dispatch({ type: 'metaData', payload: "404" });
      }
  };


  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const setSelectedGymInvoice = (GymInvoice)=>{
    dispatch({ type: 'selectedGymInvoice', payload: GymInvoice });
  }

  return(
    <GymInvoiceContext.Provider value={{
      ...state, 
      dispatch, 
      getGymInvoices,
      setCurrentPage,
      setSelectedGymInvoice
      }}>
      {children}
    </GymInvoiceContext.Provider>
  )

}

export const useGymInvoice = ()=>useContext(GymInvoiceContext);

